import React from 'react'
import { SubscribersMonitor } from '@edge-stream/observability-react'

export function SubscribersPage(): React.ReactElement {
  return <SubscribersMonitor className="page-container" showSettings={true} pollInterval={500} maxLogs={100} />
}
